import axios from 'axios';

const api = axios.create();

const postUser = (data, authorization) =>
  api.post('/cliente', data, {
    headers: {
      accept: 'application/json',
      authorization,
      'Content-Type': 'application/json',
    },
  });
const postCreditCard = (data, authorization) =>
  api.post('/tarjeta', data, { headers: { authorization } });

const putCreditCard = (token, payload, authorization) =>
  api
    .put(`/tarjeta/${token}`, payload, { headers: { authorization } })
    .then(({ data }) => data);

export default api;
export { postUser, postCreditCard, putCreditCard };
